
import { lookupConstants } from '../_constants'
const initialState = {
  sector: [],
  industry: [],
  exchange: [],
  company: [],
  users: [],
  isLoadedAll: false,
  isLoading: false
}
export function lookup(state = { ...initialState }, action) {
  state = {
    ...state,
    
  }
  console.log(action)
  switch (action.type) {
    case lookupConstants.FETCH_SECTORS_ONLY:
      return {
        ...state,
        sector: action.sector ? action.sector : [],
        isLoadedAll: action.isLoadedAll,
        isLoading: false
      }
    case lookupConstants.FETCH_SECTORS:
      return {
        ...state,
        sector: action.sector ? action.sector : [],
        isLoadedAll: action.isLoadedAll,
        isLoading: true
      }
    case lookupConstants.FETCH_INDUSTRY:
      return {
        ...state,
        industry: action.industry ? action.industry : [],
        isLoading: true
      }
    case lookupConstants.FETCH_EXCHANGE:
      return {
        ...state,
        exchange: action.exchange ? action.exchange : [],
        isLoading: true
      }
    case lookupConstants.FETCH_COMPANY:
      return {
        ...state,
        company: action.company ? action.company : [],
        isLoading: true
      }
    case lookupConstants.FETCH_USERS:
      return {
        ...state,
        users: action.users ? action.users : [],
        isLoading: true
      }
    case lookupConstants.LOADED_ALL:
      return {
        ...state,
        isLoading: !action.isLoadedAll
      }
    case lookupConstants.LOOKUP_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case lookupConstants.LOOKUP_REQUEST_END:
      return {
        ...state,
        isLoading: true
      }
    default:
      return state
  }
}
